<template>
  <div class="all-container">
    <h5 v-if="tagInUse">Files with Tag</h5>
    <div class="files-with-tag-container" v-if="tagInUse">
      <span v-for="file in filesWithTag" :key="file.key" class="file-with-tag">
          {{ file.alias }}
      </span>
    </div>
    <h2 class="tag-name"><span class="black">Tag: </span>{{ tagName }}</h2>
    <span v-if="tagInUse" class="error-message">This tag is in use and cannot be deleted.</span>
    <span v-else class="info-message">Are you sure you want to delete this tag?</span>
    <span v-if="error" class="error-message">{{ error }}</span>
    <button
      @click="deleteTag"
      :disabled="tagInUse || state == 'DELETING'"
    >
      <span v-if="state == 'INACTIVE'">Delete Tag</span>
      <div v-else class="processing-container">
        <span>Processing</span>
        <Spinner
          :size="13"
          :color="'#FF5500'"
          :borderWidth="8"
        ></Spinner>
      </div>
    </button>
  </div>
</template>

<script>

import dynamoDB from '@/aws/aws-dynamoDB';

import deleteTag from '@/handlers/deleteTag';

import Spinner from '@/components/spinner.vue';

export default {
  components: {
    Spinner,
  },
  props: {
    tagId: {
      type: String,
      required: true,
    },
    tagName: {
      type: String,
      required: true,
    },
    successCallback: {
      type: Function,
      default: e => e,
    },
  },
  data() {
    return {
      filesWithTag: [],
      state: 'INACTIVE',
      error: '',
    };
  },
  computed: {
    tagInUse() {
      return this.filesWithTag.length > 0;
    },
  },
  async created() {
    this.filesWithTag = await dynamoDB.getDBFilesByTags(this.tagId);
  },
  methods: {
    async deleteTag() {
      this.state = 'DELETING';
      // Replace this with an API call to delete the tag from your backend.
      // This is a dummy implementation that simulates a successful delete.
      await deleteTag(
        this.tagId,
        this.successCallback,
        (error) => {
          this.error = error.message;
        },
      );

      this.state = 'INACTIVE';
    },
  },
};
</script>


<style lang="stylus" scoped>
  @require '../style/colors'

  .all-container
    display: flex
    flex-direction: column
    align-items: center
    justify-content: space-between
    margin: 5px 0px

    h5
      margin-top: 1.5rem
      margin-bottom: 0.5rem

  .processing-container
    display: flex
    flex-flow: row nowrap
    align-items: center
    justify-content: center
    gap: 16px

  button
    background-color: $primary-color
    color: $white
    font-size: 1.7rem
    padding: 1.3rem 2.5rem
    border: none
    border-radius: .5rem
    cursor: pointer
    transition: background-color 0.3s ease-in-out

    &:hover
      background-color: darken($primary-color, 10%)

    &:disabled
      /* Disabled state styles */
      background-color: $secondary-color;
      cursor: not-allowed;

  .info-message
  .error-message
    margin: 0.5rem
    margin-bottom: 1.5rem
    font-size: 1.4rem
  .error-message
    background-color: $secondary-color
    color: red
    padding: 1rem
  .tag-name
    margin-bottom: 3.5rem
  .black
    color: $black

  .files-with-tag-container
    display: flex
    flex-direction: row
    flex-wrap: wrap
    justify-content: center
    align-items: center
    gap: .4rem
    width: 60rem

    .file-with-tag
      color: $black60
      background-color: $secondary-color
      padding: .3rem 2rem
      max-width: 25rem
      font-size: 1.5rem
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
</style>
